import React from 'react';
import { composeBemClasses } from '../../../ui/composeBemClasses';
import type { TvLayer } from '../../../../utils/tvPlayback';
import type { TvFill } from '../../../../utils/tvConfig';
import './TvSlide.css';

export interface TvSlideProps {
  layer: TvLayer;
  active: boolean;
  fill: TvFill;
  showCaption: boolean;
}

export const TvSlide: React.FC<TvSlideProps> = ({ layer, active, fill, showCaption }) => {
  const { slide, src } = layer;
  if (!slide || !src) {
    return null;
  }

  const className = composeBemClasses('tv-slide', [], [active && 'active', fill === 'black' && 'fill-black']);
  const caption = showCaption ? slide.caption : null;

  return (
    <div className={className} data-testid="tv-slide">
      {fill === 'blur' && <img className="tv-slide__backdrop" src={src} alt="" aria-hidden="true" data-testid="tv-slide-backdrop" />}
      <img className="tv-slide__photo" src={src} alt={slide.caption ?? slide.eventName} />
      <div className="tv-slide__overlay">
        {caption && <p className="tv-slide__caption">{caption}</p>}
        <p className="tv-slide__context">{slide.eventName} · {slide.seasonLabel}</p>
      </div>
    </div>
  );
};
